"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { Suspense, useState } from "react";
import { HamburgerButton } from "~/components/ui/hamburger-button-eon";
import { LanguageSwitcher } from "~/components/ui/language-switcher-eon";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "~/components/ui/sheet-eon";
import { useLanguage } from "~/translations/loader/use-language";
import ChevronRight from "../../../icons/chevron-right-eon";
const navItems = [{
  href: "https://www.eon-uk-careers.com/en/life-at-eon.html",
  label: "Life at E.ON"
}, {
  href: "https://www.eon-uk-careers.com/en/life-at-eon/we-have-market-leading-benefits.html",
  label: "Benefits"
}, {
  href: "https://www.eon-uk-careers.com/en/life-at-eon/we-are-flexible.html",
  label: "Flexible working"
}, {
  href: "https://www.eon-uk-careers.com/en/early-careers.html",
  label: "Early Careers"
}, {
  href: "https://www.eon-uk-careers.com/en/job-search/application-process.html",
  label: "Application Process"
}, {
  href: "https://www.eon-uk-careers.com/en/job-search/application-support.html",
  label: "Application Support"
}];
export default function HeaderMainEonUk() {
  const $ = _c(24);
  const t = useLanguage();
  const [open, setOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CustomImage alt="E.ON Logo" height={28} src="images/logo/logo_color.svg" width={96} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.header_home) {
    t1 = <CustomLink aria-label={t.header_home} className="flex items-center p-4 lg:hidden" href="/" passParams={true} prefetch={false} title={t.header_home}>{t0}</CustomLink>;
    $[1] = t.header_home;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CustomImage alt="E.ON Logo" height={28} src="images/logo/logo_color.svg" width={96} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t.header_home) {
    t3 = <li><CustomLink aria-label={t.header_home} className="flex items-center p-4 pl-0" href="/" passParams={true} prefetch={false} title={t.header_home}>{t2}</CustomLink></li>;
    $[4] = t.header_home;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = navItems.map(_temp);
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <ul className="hidden h-full items-center text-lg leading-4 lg:flex">{t3}{t4}</ul>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t1 || $[10] !== t5) {
    t6 = <nav><div className="flex h-full w-full justify-between lg:justify-between">{t1}{t5}</div></nav>;
    $[9] = t1;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Suspense><LanguageSwitcher /></Suspense>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="sr-only">Menu</span>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== open) {
    t9 = <SheetTrigger asChild={true} className="my-auto min-h-[32px] min-w-[32px] cursor-pointer lg:hidden"><button className="flex items-center gap-2" type="button">{t8}<HamburgerButton isOpen={open} /></button></SheetTrigger>;
    $[14] = open;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SheetHeader className="flex flex-row items-center justify-around"><SheetTitle className="sr-only">Menu</SheetTitle></SheetHeader>;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <SheetContent className="top-16 h-[calc(100vh-4rem)] w-[296px] border-white bg-card md:w-[305px]" showCloseButton={false} side="right">{t10}<ul className="text-lg">{navItems.map(_temp2)}</ul></SheetContent>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== open || $[19] !== t9) {
    t12 = <div className="absolute top-0 right-6 flex h-full items-center justify-center gap-5 md:right-10 md:items-center lg:static">{t7}<Sheet modal={true} onOpenChange={setOpen} open={open}>{t9}{t11}</Sheet></div>;
    $[18] = open;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t6) {
    t13 = <header className="sticky top-0 z-50 h-16 w-full bg-white text-foreground print:hidden"><div className="relative w-full border-gray-200 border-b-4"><div className="mx-auto flex h-16 max-w-screen-xl justify-between px-4 text-center">{t6}{t12}</div></div></header>;
    $[21] = t12;
    $[22] = t6;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
}
function _temp2(t0) {
  const {
    href,
    label
  } = t0;
  return <li className="border-gray-300 border-b" key={href}><CustomLink blank={true} className="flex justify-between px-8 py-3 leading-6" href={href}><span>{label}</span><ChevronRight className="size-5 text-foreground" /></CustomLink></li>;
}
function _temp(item) {
  return <li className="hover:underline hover:underline-offset-8" key={item.href}><CustomLink blank={true} className="flex h-full px-3 xl:px-4" href={item.href}><span>{item.label}</span></CustomLink></li>;
}